module.exports = __webpack_public_path__ + "img/bls-4.169dc46a.png";